import React from 'react';
import randomstring from 'uuid/v4';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

class Activity extends React.Component {

    render() {
        const { instances_opened, onClose, anchorEl } = this.props;
        console.log(anchorEl, instances_opened);
        return (
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={true}
                onClose={() => onClose(null)}
                PaperProps={{
                    style: {
                        maxHeight: 48 * 4.5,
                    },
                }}
            >
                {
                    instances_opened.slice(0, instances_opened.length - 1).map(option => (
                        <MenuItem key={randomstring()} onClick={() => onClose(option)}>
                            {
                                option.familia + " " + option.nproceso + " " + option.nlocal + " [" + option.id + "]"
                            }
                        </MenuItem>
                    ))
                }
            </Menu>
        );
    }
}

export default Activity;



// WEBPACK FOOTER //
// ./src/components/complex/forms/InstanceOpenedMenu.js